export default __webpack_public_path__ + "static/media/addDocumentIcon.f0a31b6c.svg";